import { useQuery } from '@tanstack/react-query'
import { Rocket, X } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router'
import { Card, CardHeader } from '@/components/ui/Card'
import { IconButton } from '@/components/ui/Button'
import { useAuth } from '@/features/auth/useAuth'
import { setupQuery, useSetupVisibility } from './api'
import { SetupChecklistView } from './SetupChecklistView'

/** Dashboard card for a school that is not set up yet (hidden once complete or dismissed). */
export function SetupGuideCard() {
  const { t } = useTranslation('setup')
  const { can } = useAuth()
  const setup = useQuery({ ...setupQuery(), enabled: can('school.manage') })
  const visibility = useSetupVisibility()
  const c = setup.data
  if (!c || c.complete || c.dismissed) return null
  return (
    <Card className="mb-6 overflow-hidden">
      <CardHeader
        icon={<Rocket />}
        title={t('Set up your school')}
        description={t(
          '{{done}} of {{total}} steps done — follow them in order, each one unlocks the next.',
          {
            done: c.done,
            total: c.total,
          },
        )}
        actions={
          <>
            <Link to="/admin/setup" className="text-sm font-medium text-brand-700 hover:underline">
              {t('Full guide')}
            </Link>
            <IconButton
              label={t('Hide the guide')}
              icon={<X />}
              variant="ghost"
              onClick={() => visibility.mutate(true)}
              disabled={visibility.isPending}
            />
          </>
        }
      />
      <div className="h-1.5 bg-surface-sunken" aria-hidden="true">
        <div
          className="h-full bg-brand-500 transition-all"
          style={{ width: `${(c.done / c.total) * 100}%` }}
        />
      </div>
      <SetupChecklistView checklist={c} compact />
    </Card>
  )
}
